export enum FontEnum {
    SatoshiBold = 'Satoshi-Bold',
    SatoshiLight = 'Satoshi-Light',
    SatoshiMedium = 'Satoshi-Medium',
    SatoshiRegular = 'Satoshi-Regular',
}
